import styled from '@emotion/styled/macro';
import { rem } from '@feast-it/pesto';

export const TimePicker = styled.div`
  width: 100%;

  .react-select__control {
    border-radius: ${rem(35)};
    border: 1px solid ${({ theme }) => theme.colors.blueLight};
    border-bottom-color: ${({ theme }) => theme.colors.blueLight};
    height: ${rem(46)};
    padding: 0 ${rem(28)};
    font-family: 'Walsheim', sans-serif;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 2;

    &--menu-is-open {
      border-radius: ${rem(25)};
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-color: ${({ theme }) => theme.colors.blueLight};
      box-shadow: none;
    }
  }

  .react-select__value-container {
    padding: 0;
  }

  .react-select__indicator {
    padding: 0;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__value {
    line-height: ${rem(46)};
    padding-left: ${rem(28)};
  }

  .react-select__menu {
    border: 1px solid ${({ theme }) => theme.colors.blueLight};
    border-radius: ${rem(6)};
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    overflow: hidden;
    margin-top: -${rem(1)};
    box-shadow: 0;
  }

  .react-select-container:not(.is-disabled) > .react-select__control {
    cursor: pointer;
  }
`;
